import React from "react";
import ClassNames from "classnames";

export default class Nodes extends React.Component {

  static defaultProps = {
    showBox: true,
    showLabel: true
  };

  render() {
    const { nodes, showLabel, color, align, formatPercentage, hoverNode } = this.props;
    return (
      <g>
        {(hoverNode 
          ? [...nodes.filter(o => o.key !== hoverNode),
            ...nodes.filter(o => o.key === hoverNode)]
          : nodes).map((node, i) => {
          const labelText = node.textWrap ? node.data.key.split(" ") : node.data.key;
          const left = align === "left";
          if (node.value === 0) {
            return null;
          }
          let label;
          if (!showLabel || (!node.showLabel && hoverNode !== node.key)) {
            label = null;
          } else if (node.showLabel) {
            label = (
              <text
                fill={node.textColor}
                textAnchor={left ? "start" : "end"}
                className={ClassNames({
                  "fade-out": node.textFadeOut
                })}
              >
                {node.textWrap
                  ? <tspan>
                      <tspan
                        x={0}
                        dx={5 * (left ? 1 : -1)}
                        dy={node.textYOffset}
                        className={ClassNames({
                          bold: true,
                          inside: node.treemapLayout,
                          smallText: true,
                        })}
                      >
                        {labelText[0]}
                      </tspan>
                      <tspan
                        x={0}
                        dx={5 * (left ? 1 : -1)}
                        dy={node.secondLineOffset}
                        className={ClassNames({
                          bold: true,
                          inside: node.treemapLayout,
                          smallText: true,
                        })}
                      >
                        {labelText.length > 2 ? labelText.slice(1).join(' ') : labelText[1]}
                      </tspan>
                    </tspan>
                  : <tspan
                      x={0}
                      dx={5 * (left ? 1 : -1)}
                      dy={node.textYOffset}
                      className={ClassNames({
                        bold: true,
                        inside: node.treemapLayout,
                        smallText: true,
                      })}
                    >
                      {labelText}
                    </tspan>}
                <tspan
                  dy={node.labelYOffset}
                  x={node.percentageX + node.percentageInsidePosition}
                  dx={node.labelXOffset * (left ? 1 : -1)}
                  className={ClassNames({
                    inside: node.percentageInsideClass,
                    smallText: true
                  })}
                >
                  {formatPercentage(node.percentage)}
                </tspan>
              </text>
            );
          } else if (hoverNode === node.key) {
            label = (<g>
              {["shadow-back","shadow-front"].map(cl => 
                <text
                  fill={node.textColor}
                  textAnchor={left ? "start" : "end"}
                  key={cl}
                  className={ClassNames({
                    "fade-out": node.textFadeOut,
                    [`${cl}`]: true
                  })}
                >
                  {node.textWrap
                    ? <tspan>
                        <tspan
                          x={0}
                          dx={5 * (left ? 1 : -1)}
                          dy={node.textYOffset}
                          className={ClassNames({
                            bold: true,
                            inside: node.treemapLayout,
                            smallText: true,
                          })}
                        >
                          {labelText[0]}
                        </tspan>
                        <tspan
                          x={0}
                          dx={5 * (left ? 1 : -1)}
                          dy={node.secondLineOffset}
                          className={ClassNames({
                            bold: true,
                            inside: node.treemapLayout,
                            smallText: true,
                          })}
                        >
                          {labelText.length > 2 ? labelText.slice(1).join(' ') : labelText[1]}
                        </tspan>
                      </tspan>
                    : <tspan
                        x={0}
                        dx={5 * (left ? 1 : -1)}
                        dy={node.textYOffset}
                        className={ClassNames({
                          bold: true,
                          inside: node.treemapLayout,
                          smallText: true,
                        })}
                      >
                        {labelText}
                      </tspan>}
                  <tspan
                    dy={node.labelYOffset}
                    x={node.percentageX + node.percentageInsidePosition}
                    dx={node.labelXOffset * (left ? 1 : -1)}
                    className={ClassNames({
                      inside: node.percentageInsideClass,
                      smallText: true
                    })}
                  >
                    {formatPercentage(node.percentage)}
                  </tspan>
                </text>)}
            </g>);
          }

          return (
            <g
              className={ClassNames("node",{
                [`node-id-${node.key}`]: true,
                "hovered": node.key === hoverNode,
              })}
              key={node.key + i}
              transform={`translate(${node.x0},${node.y0})`}
              style={{ opacity: node.opacity }}
              onMouseEnter={() => {
                this.props.setHoverNode(node.key);
              }}
              onMouseLeave={() => {
                this.props.setHoverNode(null);
              }}
            >
              {align === "right" // layout === barChart -> larger hover target surface
                ? <rect className="extra-hover-target"
                    x={node.x1 - node.x0}
                    width={node.x2 - node.x1}
                    height={node.y1 - node.y0}
                    fill="#888" />
                : null}
              <rect
                width={node.x1 - node.x0}
                height={node.y1 - node.y0}
                fill={color}
              />
              <g>
                {label}
              </g>
            </g>
          );
        })}
      </g>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Graphic/Nodes.js